import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4 } from '@bigcommerce/big-design';

import { thresholdDelete } from '../../../redux/actions/thresholds';

const DeleteThresholdModal = ({ payload, locationId, showDeleteThresholdModal, setShowDeleteThresholdModal, threshold, thresholdName, deleteThreshold }) => {
  const update = () => {
    deleteThreshold(payload, locationId, threshold)
    setShowDeleteThresholdModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDeleteThresholdModal(false),
        },
        { text: 'Remove Threshold', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Remove Threshold"
      isOpen={showDeleteThresholdModal}
      onClose={() => setShowDeleteThresholdModal(false)}
    >
      <H3>{thresholdName}</H3>
      <H4>Curent Target Inventory</H4>
      {threshold?.target_inventory}

      <H4>Curent Low Inventory</H4>
      {threshold?.low_inventory}

      <H4>Curent Critical Inventory</H4>
      {threshold?.critical_inventory}
    </Modal>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  deleteThreshold: (payload, locationId, threshold) => dispatch(thresholdDelete(payload, locationId, threshold)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteThresholdModal);